import { useTrackMutation } from '@mote/api'
import { TRACK_EVENT_NAMES } from '@mote/helpers/constants'

type TrackAction = 'clicked_whats_this' | 'clicked_dismiss' | 'clicked_turn_on'

export const TRACK_ACTIONS: Record<string, TrackAction> = {
  CLICKED_WHATS_THIS: 'clicked_whats_this',
  CLICKED_DISMISS: 'clicked_dismiss',
  CLICKED_TURN_ON: 'clicked_turn_on'
}

export type UseLoopsOnboardingTrack = {
  clickedWhatsThis: () => void
  clickedDismiss: () => void
  clickedTurnOn: () => void
}

export const useLoopsOnboardingTrack = (): UseLoopsOnboardingTrack => {
  const trackMutation = useTrackMutation()

  function handleTrack(action: TrackAction, extraPayload = {}): void {
    trackMutation.mutate({
      variables: {
        event: TRACK_EVENT_NAMES.loop.action.onboarding,
        actionTaken: action,
        ...extraPayload
      }
    })
  }

  return {
    clickedWhatsThis: () => handleTrack(TRACK_ACTIONS.CLICKED_WHATS_THIS),
    clickedDismiss: () => handleTrack(TRACK_ACTIONS.CLICKED_DISMISS),
    clickedTurnOn: () => handleTrack(TRACK_ACTIONS.CLICKED_TURN_ON)
  }
}
